export default __webpack_public_path__ + "static/media/blogpost5.6c57bdaa.jpg";